<app-alert-modal
  #subscriptionSelect
  [headerLabel]="modalHeader"
  [showConfirmationBtn]="false"
  (canceled)="handleCancel()"
  dynamicClass="subscription-select-container"
  [modalOptions]="modalOptions"
>
  <div class="d-flex flex-column c-gap-30 text-left sub-select-modal">
    <div class="modal-header-label">
      {{
        messages.TO_UNLOCK_SUBSCRIBE_PLAN?.replace(
          '[content]',
          (headerType || contentType).toUpperCase()
        ).replace('[name]', fullName)
      }}
    </div>
    <app-profile-detail [userProfile]="userProfile"></app-profile-detail>

    <div class="modal-header-label-bold">
      {{ labels.SELECT_SUBSCRIPTION_PLAN }}
    </div>
    <div class="d-flex flex-column gap-3 subs-body" *ngFor="let data of availableSubList">
      <app-button
        [disabled]="!data.active"
        [btnField]="{
          label: data?.name,
          class: 'btn btn-primary w-100'
        }"
        (handleButtonClick)="openSubscriptionDetail(data)"
      ></app-button>
       <span class="subsciption-free-trail" *ngIf="!data?.subscribed && data?.is_trial_active">{{Fields.FREE_TRIAL}}</span>
    </div>
  </div>
</app-alert-modal>
